/**
 * formatDate — used by DuplicateRow to render the scan's `created_at`
 * as a short human-readable date in the user's locale. Falls back to
 * empty string on parse errors so a bad timestamp never blows up a row.
 */
export function formatDate(iso, locale) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString(locale || "en", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  } catch {
    return "";
  }
}
